import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { setDownloadPending } from "./PanoramaSlice"
import { selectActivatedFireId } from "features/map/control/selectors"
import {
    DownloadButtonData,
    NestedDownloadData,
} from "@nova/component-export-download-buttons-hover"
import { selectSelectedLayerIds } from "panels/content/side-panel/slice.new"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { downloadUriSameOrigin } from "tools/browser/download"
import { Licenses } from "@nova/constants"
import { selectPanoramaImageByFlightId } from "features/entity-caching/images/panorama/selectors"
import { selectPanoramaFlightById } from "features/entity-caching/flights/selectors"
import { createPanoramaImageUrl } from "./module"

export const useDownloadButtonData = (): DownloadButtonData => {
    const dispatch = useAppDispatch()
    const workspaceId = useAppSelector(selectActiveWorkspaceId())
    const fireId = useAppSelector(selectActivatedFireId) as string
    const selectedLayerId = useAppSelector(selectSelectedLayerIds).at(-1)
    const id = selectedLayerId || ""
    const panorama = useAppSelector(selectPanoramaFlightById(id))
    const image = useAppSelector(selectPanoramaImageByFlightId(id))

    if (!image) return { exportOptions: {} }

    const downloadButtonData: NestedDownloadData = {}

    const downloadImage = async () => {
        if (!workspaceId) return

        dispatch(setDownloadPending(true))

        try {
            const url = await createPanoramaImageUrl(
                workspaceId,
                fireId,
                panorama.demoId || id,
                image.id,
                !!panorama.demoId
            )
            const parts = image.id.split(".")
            await downloadUriSameOrigin(
                parts[0] + "." + parts.at(-1),
                url,
                panorama.demoId ? "omit" : "include"
            )
            dispatch(setDownloadPending(false))
        } catch (e) {
            console.error(e)
            dispatch(setDownloadPending(false))
        }
    }

    downloadButtonData.Image = { callback: downloadImage, restrictedLicenses: [Licenses.Lite] }

    return { exportOptions: downloadButtonData }
}
